import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CarouselComponent } from 'src/app/layouts/carousel/carousel.component';

@Component({
    selector: 'app-test-detail-candidates',
    templateUrl: './test-detail-candidates.component.html',
    styles: [],
    standalone: true,
    imports: [CarouselComponent, CommonModule]
})
export class TestDetailCandidatesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
